import script from "./DeleteBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteBtn.vue?vue&type=script&setup=true&lang=js"

import "./DeleteBtn.vue?vue&type=style&index=0&id=397e356c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-397e356c"]])

export default __exports__